<template>
  <!-- 直播讲座 -->
  <div class="container">
    <div class="live-container">
      <div class="item-container" v-for="item in froliveArrm" :key="item.id">
        <!-- @click="viewLiving(item.page_url)" -->
        <!-- <span v-show="item.alive_state == 0">未开始</span>
            <span v-show="item.alive_state == 1">直播中</span>
            <span v-show="item.alive_state == 2">已结束</span>1  13
            开始时间：{{ item.alive_start_at }}
            观看人数{{ item.view_count }} 订阅量{{ item.purchase_count }}
            结束时间：{{ item.alive_stop_at }} -->
        <!-- {{ item }} -->
        <div class="start_time">{{ item.alive_start_at }}</div>
        <div class="card">
          <img class="img" :src="item.img_url" alt="" />
          <div class="card_content">
            <div class="title">相约星期二教师教研日</div>
            <div class="sub_title">{{ item.title }}</div>
            <div class="start_time">开始时间：{{ item.alive_start_at }}</div>
            <div class="start_time">结束时间：{{ item.alive_stop_at }}</div>
            <el-button type="primary" @click="viewLiving(item.page_url)">进入直播</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "LiveLecture",
  props: ["froliveArrm", "active"],
  data() {
    return {};
  },
  methods: {
    viewLiving(url) {
      window.open(url);
    },
  },
  created() {
    // 调接口获取数据
  },
  mounted() {},
};
</script>
<style lang="less" scoped>
.live-container {
  height: 3.8194rem;
  // border: 1px solid red;
  margin-bottom: 0.1389rem;
  overflow: hidden;
  overflow-y: auto;
  .item-container {
    width: 5.2014rem;
    // border: 1px solid aqua;
    margin-left: 0.2083rem;
    margin-bottom: 0.1736rem;
    .start_time {
      font-size: 0.125rem;
      font-weight: 400;
      letter-spacing: 0px;
      line-height: 0.181rem;
      color: rgba(0, 0, 0, 1);
    }
    .card {
      margin-left: 0.1528rem;
      width: 5.1875rem;
      height: 1.3333rem;
      border-radius: 0.1667rem;
      background-color: #fff;
      display: flex;
      margin-top: 0.1042rem;
      .img {
        width: 2.3264rem;
        height: 1.3333rem;
        border-radius: 0.1667rem 0 0 0.1667rem;
        // border: 1px solid red;
      }
      .card_content {
        flex: 1;
        box-sizing: border-box;
        padding: 0.1111rem 0 0 0.1597rem;
        position: relative;
        .title {
          font-size: 0.1111rem;
          font-weight: 700;
          letter-spacing: 0px;
          line-height: 0.1515rem;
          color: rgba(0, 0, 0, 1);
        }
        .sub_title {
          font-size: 0.0972rem;
          font-weight: 400;
          letter-spacing: 0px;
          line-height: 0.1515rem;
          color: rgba(0, 0, 0, 1);
          text-align: left;
          vertical-align: top;
          margin-top: 0.1389rem;
          margin-bottom: .3472rem;
        }
        .start_time {
          font-size: .0833rem;
          font-weight: 400;
          letter-spacing: 0px;
          line-height: .1137rem;
          color: rgba(0, 0, 0, 1);
          text-align: left;
          vertical-align: top;
          margin-bottom: .0347rem;
        }
      }
      .el-button{
        position: absolute;
        color: #fff;
        bottom: .0833rem;
        right:.1042rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/teacher/LiveLecture.vue